/* eslint-disable */
function Legend(props) {
    const { modeName = '' } = props;
    return (
        <div className='flex items-center gap-4 text-xs mt-2'>
            <div className='flex items-center gap-1'>
                <div className='w-3 h-3 bg-red-100 border border-red-300 rounded' />
                <span>Item names conflict</span>
            </div>
            <div className='flex items-center gap-1'>
                <div className='w-3 h-3 bg-yellow-100 border border-yellow-300 rounded' />
                <span>Auto-added from dropdown, Parts matched by name</span>
            </div>
            <div className='flex items-center gap-1'>
                <div className='w-3 h-3 bg-green-100 border border-green-300 rounded' />
                <span>Client Variant Id match</span>
            </div>
            {modeName === 'dataEntry' && (
                <div className='flex items-center gap-1'>
                    <div className='w-3 h-3 bg-orange-100 border border-orange-300 rounded' />
                    <span>Fulfilled qty exceeds ordered qty</span>
                </div>
            )}
        </div>
    )
}
export default Legend;